import { writable, get, type Writable } from "svelte/store"

//
// This is a little script I wrote to observe certain
// elements (header and footer) and append a stylesheet
// so that other css elements can know their value.
// This allows the navigation for example to be available on desktop
// and sitting nicely tucked between the header and footer

// const resizeObservers = new Map<string, ResizeObserver>()

// const cssValues = writable(new Map<string, string>())
// export function updateCssValue(cssVariable : string, value : string) {
//     get(cssValues).set(cssVariable, value)
//     cssValues.update(x => x)
// }

// // const stylesheet = document.createElement("style")
// // stylesheet.setAttribute("type", "text/css")
// // document.head.append(stylesheet)

// cssValues.subscribe(values => {
//     for (const [vari, value] of values) {
//         // document.documentElement.style.setProperty('--' + vari, value)
//     }
//     // stylesheet.innerText = `html {${[...values.entries()].map(([cssVariable, value]) => `--${cssVariable}: ${value};`).join("")}}`
// })

// function newCallback(variable : string, fn : (e: ResizeObserverEntry) => string = (e) => e.contentRect.height + "px") {
//     const processObservation : ResizeObserverCallback = (entries) => {
//         for (const entry of entries) {
//             updateCssValue(variable, fn(entry))
//         }
//     }
//     return processObservation
// }

//
// function makeOrCreateResizeObserver(cssVariable : string, fn : (e: ResizeObserverEntry) => string) {
//     if (resizeObservers.has(cssVariable)) {
//         return resizeObservers.get(cssVariable)
//     } else {
//         const newObserver = new ResizeObserver(newCallback(cssVariable, fn))
//         resizeObservers.set(cssVariable, newObserver)
//         return newObserver
//     }
// }

function createObserver<T>(store: Writable<T>, fn: (e: ResizeObserverEntry) => T) {
    const newObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            store.set(fn(entry))
        }
    })
    return newObserver
}

export function resizeEntryBorderBoxBlockSize(entry: ResizeObserverEntry) {
    const borderBoxSize = Array.isArray(entry.borderBoxSize)
        ? entry.borderBoxSize[0]
        : entry.borderBoxSize

    return borderBoxSize?.blockSize ?? entry.target.getBoundingClientRect().height
}

// Svelte use directive for header and footer
export function cssObserver<T>(
    node: HTMLElement,
    params: { store: Writable<T>; fn: (e: ResizeObserverEntry) => T },
) {
    const observer = createObserver(params.store, params.fn)
    observer.observe(node)

    return {
        destroy() {
            observer.unobserve(node)
        },
    }
}

/**
 *  Here we have a similar setup but for appending classes to HTML rather than adding attributes to css variables
 */
//

const htmlClasses = writable(new Map<string, boolean>())

export const updateHtmlClass = (className: string, value: boolean) => {
    get(htmlClasses).set(className, value)
    htmlClasses.update((x) => x)
}

htmlClasses.subscribe((values) => {
    // Get html element
    const html = document.documentElement
    values.forEach((on, className) => {
        if (on) {
            html.classList.add(className)
        } else {
            html.classList.remove(className)
        }
    })
})
